export default {
  title: 'Nakonfigurovať novú vsázku',
  submitLabel: 'Načítaná {recipeCode}',
};
